/**
 * Edit Studio Review Route
 * Route: /studios/:studioId/reviews/:reviewId/edit
 *
 * The form UI lives in the .lazy.tsx file; nothing SSR-relevant remains here.
 * This route sits under the public layout, which no longer gates anything, so
 * the session requirement is enforced here. Editing your own review is identity
 * scoped: the API rejects an unauthenticated or non-owner write regardless.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_public/studios/$studioId/reviews/$reviewId/edit')({
  // Form-shaped pending while the lazy chunk downloads; title matches the page
  // the route becomes (aria-labelled, kept out of the visual tree as a block).
  pendingComponent: () => <FormPageTemplatePending title="Edit your review" cta />,
  beforeLoad: ({ context, location }) => {
    if (context.authState === 'unauthenticated') {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
});
